import { Component, Vue, Watch } from "vue-property-decorator";
import { isIINBIN } from "@/utils";
import * as EmailValidator from 'email-validator';

@Component
export default class extends Vue {
  protected formRef = "form-validator-ref";
  get rules() {
    return {
      account: (value: string) => {
        const pattern = /^(\d{1,10})$/;
        return pattern.test(value) || this.$t("form-validator.accountId");
      },
      accountId: (value: string) => {
        return (
          this.checkAccControlSum(value) || this.$t("form-validator.accountId")
        );
      },
      required: (value: string) => {
        return typeof value === "boolean" || typeof value === "number"
          ? true
          : !!value || this.$t("form-validator.required");
      },
      spaced: (value: string) => {
        const str = value ? value : "";
        return (
          (str && str.trim().length > 0) || this.$t("form-validator.required")
        );
      },
      decimal2: (value: string) => {
        const pattern = /^(\d{1,7})(\.\d{1,2})*$/;
        return pattern.test(value) || this.$t("form-validator.decimal2");
      },
      decimal22: (value: string) => {
        const summ = Number.parseFloat(value);
        return summ > 0 || this.$t("form-validator.decimal2");
      },
      decimal: (value: string) => {
        const pattern = /^(\d{1,10})$/;
        return pattern.test(value) || this.$t("form-validator.decimal");
      },
      selectRequired: (value: any[]) => {
        if (!value) return true;
        return !!value.length || this.$t("form-validator.required");
      },
      stringLengthMaxMin: (max: number, min: number) => (value?: string) => {
        const fmax = this.stringLengthMax(max)(value);
        if (typeof fmax == "string") return fmax;
        const fmin = this.stringLengthMin(min)(value);
        if (typeof fmin == "string") return fmin;

        return true;
      },
      stringLengthMax: this.stringLengthMax,
      stringLengthMin: this.stringLengthMin,
      isNumber: (value: string) => {
        const x = Number.parseInt(value);
        return x !== null && !isNaN(x) || this.$t("form-validator.number");
      },
      iin: this.iinBin("iin"),
      bin: this.iinBin("bin"),
      email: (value: string) => {
        const pattern = /^[a-zA-Z\d]{1,}[a-zA-Z\d._-]{1,}[a-zA-Z\d]{1,}@[a-zA-Z\d.-]+\.[a-zA-Z]{2,4}$/;
        const match = value ? value.match("([._-]{1,}[._-]{1,})") : false;
        return (
          (EmailValidator.validate(value) && pattern.test(value) && !match) ||
          this.$t("form-validator.email")
        );
      },
      PasswordRequired: (value: string) => {
        return typeof value === "boolean" || typeof value === "number"
          ? true
          : !!value || this.$t("auth-view.enter_pass");
      },
      passwordRequirments: (value: string) => {
        if (!value) return this.$t("form-validator.required");
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})(?!.*[а-яА-ЯёЁіІЇїєЄ])(?=.*[@#$%&])(?!.* )/;
        return pattern.test(value) || this.$t("form-validator.pass");
      },
    };
  }

  validateForm() {
    //!!во всех компонентах которые используют этот примесь нужно в компоненте указать formRef-ссылка на контейнер формы
    return (this.$refs[this.formRef] as Vue & {
      validate: () => boolean;
    }).validate();
  }

  @Watch("$i18n.locale") resetFormValidation() {
    (this.$refs[this.formRef] as Vue & {
      resetValidation: () => void;
    }).resetValidation();
  }

  private iinBin(type: "iin" | "bin") {
    return (value: string) => {
      if (!value || isIINBIN(value)) return true;
      return this.$t("form-validator." + type);
    };
  }

  private stringLengthMax(max: number) {
    return (value = "") => {
      if (value && max && value.length > max) {
        return this.$t("form-validator.string-max", { max });
      }
      return true;
    };
  }
  private stringLengthMin(min: number) {
    return (value = "") => {
      if (value && min && value.length < min) {
        return this.$t("form-validator.string-min", { min });
      }
      return true;
    };
  }
  public checkAccControlSum(AccountId: string): boolean {
    const Account: string = (
      1000000000 + Number.parseInt(AccountId)
    ).toString();
    let sum: number = 0;
    let i: number = 4;
    while (i <= 9) {
      sum = sum + i * Number.parseInt(Account.substring(i - 1, i));
      i++;
    }
    const ss = (sum % 11).toString();
    return ss.substring(ss.length - 1) == Account.substring(Account.length - 1);
  }
}
